import React, { useState, useRef, useEffect, ReactNode } from "react";

import "./styles.css";
const LoadingSpinner = () => {
  return (
    <div>
      <div className="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
